// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/assets/css/common.css';
import {parentRouteStack} from "./assets/js/reusableFunctions";
import {post,get,login,logout,getBreath} from './service/service'
import VueClipboard from 'vue-clipboard2'
import permissions from './assets/js/permissions'
import {permissionsFunction} from "./assets/js/reusableFunctions";
import {permissionMap} from "./assets/js/constant";

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

//非权限控制 路由（/router/*.js中任意路由）
const accessWithNoPermission = [];
//非权限控制 一级路由（/router/index.js中的根路由）
const accessWithNoPermissionRoot0 = ['login', 'updateBrowser','serviceDetail','servicePreview'];
//非权限控制 二级路由（/router/twoLevelRouter.js中的根路由）
const accessWithNoPermissionRoot1 = ['statisticalInfo', 'demandRecord','contentManagement','caseManagement','onlineService','infoManagement','userManagement','personalData'];

router.beforeEach((to, from, next) => {
  Vue.prototype.__cancels__.forEach((cancel) => {
    cancel();
  });
  Vue.prototype.__cancels__ = [];
  if (sessionStorage.getItem('currentUser') === null) {//无登录信息
    //后台身份验证
    // if (to.name === 'login') {
    //   next();
    // }
    // else {
    //   next({name: 'login'});
    // }
    Vue.prototype.$getBreath('/user/current/user').then(data=>{
      if(data){
        sessionStorage.setItem('currentUser', JSON.stringify(data));
        if (to.name === 'main' || to.name === 'login') {
          next({name:'statisticalInfoMain'});
        }
        else {
          next({name: to.name});
        }
      }else {//验证未通过
        if (to.name === 'login') {
          next();
        }
        else {
          next({name: 'login'});
        }
      }
    })
  }
  else {//正常时
    let prs = parentRouteStack(to.name, router.options.routes).reverse();
    if (to.name) {
      //合法路由
      if (to.name === 'main') {
        //空白路由
        next({name: 'statisticalInfoMain'});
      }
      else if (
        accessWithNoPermission.indexOf(to.name) >= 0
        || (prs.length > 0 && accessWithNoPermissionRoot0.indexOf(prs[0].name) >= 0)
        || (prs.length > 1 && accessWithNoPermissionRoot1.indexOf(prs[1].name) >= 0)
        || (prs.length > 1 && permissionsFunction(permissionMap[prs[1].name].view) === true)
      //目标路由 为非权限控制路由
      //目标路由的一级路由 为非权限控制一级路由
      //目标路由的二级路由 为非权限控制二级路由
      //目标路由的二级路由 已有权限（权限配置实际控制到的层级）
      ) {
        //可访问路由
        next();
      }
      else {
        //无权限路由
        next({name: 'statisticalInfoMain'});
      }
    }
    else {
      //非法路由
      next({name: 'statisticalInfoMain'});
    }
  }
});

//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$get=get;
Vue.prototype.$login=login;
Vue.prototype.$logout=logout;
Vue.prototype.$getBreath = getBreath;

Vue.use(ElementUI);
Vue.use(VueClipboard);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js